import Component from "./HomepageFeatures";
export default Component;
